import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-sla-management',
  imports: [RouterModule, FeatureHero],
  templateUrl: './sla-management.html',
  styleUrl: './sla-management.scss',
})
export class SlaManagement {

}
